import { useEffect, useMemo, useState } from 'react';
import useAxios from '../../../../hooks/useAxios';
import { useDownloadOptions } from '../../../../hooks/useDownloadOptions';
import { toaster } from '../../../../utils/toast';
import XButton from "../../../../components/common/XButton";
import { FiDownload } from "react-icons/fi";
import AccordionItem from '../../../../components/common/accordionItem';
import ReportTable from './ReportTable';

const ReportSummary = ({ config }) => {
    const { title, description, columns, csvType, transformData, additionalComponent:AdditionalComponent, tableClassName = "",apiPayLoad,apiEndpoint } = config;
    const { downloadCsvFile } = useDownloadOptions();
    const { getData,postData, isLoading } = useAxios();
    const [tableData, setTableData] = useState([]);
    const [additionalData, setAdditionalData] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = apiPayLoad ? await postData(apiEndpoint(),apiPayLoad()) :await getData(apiEndpoint());
                if (!response.success) {
                    toaster({ message: response.message, success: response.success });
                    return;
                }
                
                const transformed = transformData ? transformData(response?.data) : {tableData:response?.data};
                setTableData(transformed.tableData);
                setAdditionalData(transformed.additionalData || {});
            } catch (error) {
                console.error(`Error fetching report details:`, error);
            }
        };
        fetchData();
    }, [getData, apiEndpoint, transformData, apiPayLoad, postData]);

    const report = useMemo(() => ({
        title: (
            <span className="text-base text-content font-semibold">
                {title} {tableData.length > 0 && `(${tableData.length})`}
            </span>
        ),
        description,
        columns: columns(),
        rows: tableData,
    }), [tableData, title, description, columns]);

    return (
        <div>
            <AccordionItem title={report.title} className="mt-6">
                <div className="flex items-center justify-between mb-4 sticky top-0 bg-white">
                    <p className="m-0! text-sm text-subtle">
                        {description}
                    </p>
                    <XButton
                        variant="close"
                        className="p-0! text-sm no-underline! flex items-center font-semibold border-0! text-primary!"
                        onClick={() => downloadCsvFile({ type: csvType })}
                        disabled={isLoading || tableData.length === 0}
                    >
                        <span className="mr-1!">Export CSV</span>
                        <FiDownload />
                    </XButton>
                </div>

                {AdditionalComponent && (
                    <AdditionalComponent 
                        additionalData={additionalData} 
                        isLoading={isLoading} 
                    />
                )}

                <ReportTable
                    isLoading={isLoading}
                    columns={report.columns}
                    rows={report.rows}
                    tableClassName={tableClassName}
                />
            </AccordionItem>
        </div>
    );
};

export default ReportSummary;